import { T as Translator } from './translator-c311ba49.js';
import { D as DictionarySerializer } from './dictionarySerializer-969da3d0.js';

class DictionaryTranslator {
    static getDescriptionTranslation(dto, languages) {
        var _a;
        const translation = Translator.getTranslation(dto.description, languages);
        return (_a = translation === null || translation === void 0 ? void 0 : translation.content) !== null && _a !== void 0 ? _a : dto === null || dto === void 0 ? void 0 : dto.code;
    }
    static getCodeDescriptionTranslation(dto, languages) {
        const translation = Translator.getTranslation(dto.description, languages);
        return DictionarySerializer.getCodeDescriptionDisplay({
            code: dto.code,
            description: translation === null || translation === void 0 ? void 0 : translation.content,
        });
    }
    static getNameTranslation(dto, languages) {
        var _a;
        const translation = Translator.getTranslation(dto.name, languages);
        return (_a = translation === null || translation === void 0 ? void 0 : translation.content) !== null && _a !== void 0 ? _a : dto.code;
    }
    static getCodeNameTranslation(dto, languages) {
        const translation = Translator.getTranslation(dto.name, languages);
        return DictionarySerializer.getCodeDescriptionDisplay({
            code: dto.code,
            description: translation === null || translation === void 0 ? void 0 : translation.content,
        });
    }
}

export { DictionaryTranslator as D };
//# sourceMappingURL=dictionaryTranslator-6f7eced2.js.map
